import { t } from "../i18n";
import type { StaticEvidenceProvider } from "../data/provider";

export function MethodologyPage({ provider }: { provider: StaticEvidenceProvider }) {
  return (
    <article class="obs-page obs-method-page">
      <p class="obs-eyebrow">{t("brand.observatory")}</p>
      <h1>{t("method.pageTitle")}</h1>
      <section>
        <h2>{t("method.purpose.title")}</h2>
        <p>{t("method.purpose.body")}</p>
      </section>
      <section>
        <h2>{t("method.pillars.title")}</h2>
        <p>{t("method.pillars.body")}</p>
        <ol class="obs-method-pillars">
          <li>
            <strong>{t("method.pillar.understand")}</strong>
            <p>{t("method.pillar.understand.body")}</p>
          </li>
          <li>
            <strong>{t("method.pillar.design")}</strong>
            <p>{t("method.pillar.design.body")}</p>
          </li>
          <li>
            <strong>{t("method.pillar.develop")}</strong>
            <p>{t("method.pillar.develop.body")}</p>
          </li>
          <li>
            <strong>{t("method.pillar.deliver")}</strong>
            <p>{t("method.pillar.deliver.body")}</p>
          </li>
        </ol>
      </section>
      <section>
        <h2>{t("method.model.title")}</h2>
        <p>{t("method.model.body")}</p>
      </section>
      <section>
        <h2>{t("method.framework.title")}</h2>
        <p>{t("method.framework.body")}</p>
      </section>
      <section>
        <h2>{t("method.scoring.title")}</h2>
        <p>{t("method.scoring.body")}</p>
      </section>
      <section>
        <h2>{t("method.limits.title")}</h2>
        <p>{t("method.limits.body")}</p>
      </section>
      <section>
        <h2>{t("method.sources.title")}</h2>
        <ul class="obs-resource-list">
          {provider.sources().map((s) => (
            <li key={s.id}>
              <h3>{s.name}</h3>
              <p>
                {s.organization} — {s.title}
                {s.date ? `, ${s.date}` : ""}. {s.notes}
              </p>
              {s.url ? (
                <a href={s.url} rel="noopener noreferrer">
                  {t("learn.open")}
                </a>
              ) : null}
            </li>
          ))}
        </ul>
      </section>
      <section>
        <h2>{t("method.update.title")}</h2>
        <p>{t("method.update.body", { date: provider.lastReviewedAt() })}</p>
        <p>{provider.catalog.meta.contentNotice}</p>
      </section>
    </article>
  );
}
